const React = require("react");
const { useSyncee } = require("../context/SynceeContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const DropshippingImportedProducts = () => { const { t } = useSyncee(); return h(ProductCollectionPage, { imported: true, title: t("h_syncee_imported_products", "Imported Syncee products"), description: t("h_syncee_imported_products_desc", "Products already linked to your Elakay shop.") }); };
module.exports = { DropshippingImportedProducts };
